            <!-- Navbar -->
       <div class="content">
        <div class="content">
        <div class="container-fluid">
        <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>MASTER MODULE</h2>
         <p>List Of modules</p>
        <!--  <a href="#" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
           Back
         </a>-->
       </div>
      </div>
       <div class="row">

        <div [hidden]="isHidden" class="col-lg-4 col-md-6 col-sm-6">
          <a  [routerLink]="['/dashboard','farmsmanagement']"  routerLinkActive="active-link" ><div class="card card-stats"  style="cursor:pointer">
               <div class="card-header card-header-warning card-header-icon">
                <p class="card-category">FARMS MANAGEMENT</p>
               </div>
               <div class="card-icon">
                <img alt="" src="assets/images/Farm_Management.png" />
               </div>
               <!--<div class="card-footer">
               <div class="stats">
                 <i class="material-icons text-danger">warning</i>
                 <a href="#pablo">Get More Space...</a>
               </div>
             </div>-->
           </div></a>
         </div>

         <div  [hidden]="isHiddenguest" class="col-lg-4 col-md-6 col-sm-6">
          <a  [routerLink]="['/dashboard','speciesmanagement']"  routerLinkActive="active-link" ><div class="card card-stats"  style="cursor:pointer">
               <div class="card-header card-header-warning card-header-icon">
                <p class="card-category">SPECIES MANAGEMENT</p>
               </div>
               <div class="card-icon">
                <img alt="" src="assets/images/Species_Management.png" />
               </div>
             <!--<div class="card-footer">
               <div class="stats">
                 <i class="material-icons text-danger">warning</i>
                 <a href="#pablo">Get More Space...</a>
               </div>
             </div>-->
           </div></a>
         </div>

         <div  [hidden]="isHiddenguest" class="col-lg-4 col-md-6 col-sm-6">
          <a [routerLink]="['/dashboard','breedsmanagement']"  routerLinkActive="active-link"><div class="card card-stats" style="cursor:pointer">
               <div class="card-header card-header-warning card-header-icon">
                <p class="card-category">BREEDS MANAGEMENT</p>
               </div>
               <div class="card-icon">
                <img alt="" src="assets/images/breeds_management.png" />
               </div>
             <!--<div class="card-footer">
               <div class="stats">
                 <i class="material-icons text-danger">warning</i>
                 <a href="#pablo">Get More Space...</a>
               </div>
             </div>-->
           </div></a>
         </div>

         <div class="col-lg-4 col-md-6 col-sm-6">
          <a  [routerLink]="['/dashboard','stockmanagement']"  routerLinkActive="active-link" ><div class="card card-stats"  style="cursor:pointer">
               <div class="card-header card-header-warning card-header-icon">
                <p class="card-category">STOCK MANAGEMENT</p>
               </div>
               <div class="card-icon">
                <img alt="" src="assets/images/Stock_Category_Management.png" />
               </div>
             <!--<div class="card-footer">
               <div class="stats">
                 <i class="material-icons text-danger">warning</i>
                 <a href="#pablo">Get More Space...</a>
               </div>
             </div>-->
           </div></a>
         </div>
         
        <!--<div class="col-lg-4 col-md-6 col-sm-6">
           <a  [routerLink]="['/dashboard','diseasemanagement']"  routerLinkActive="active-link" ><div class="card card-stats" style="cursor:pointer">
            <div class="card-header card-header-warning card-header-icon">
                <p class="card-category">DISEASE MANAGEMENT</p>
               </div>
               <div class="card-icon">
                <img alt="" src="assets/images/Disease_Management.png" />
               </div>

           </div></a>
         </div>
              
         <div class="col-lg-4 col-md-6 col-sm-6">
          <a  [routerLink]="['/dashboard','vaccinemanagement']"  routerLinkActive="active-link" ><div class="card card-stats" style="cursor:pointer"> 
               <div class="card-header card-header-warning card-header-icon">
                <p class="card-category">VACCINE MANAGEMENT</p>
               </div>
               <div class="card-icon">
                <img alt="" src="assets/images/Vaccine_management.png" />
               </div>

           </div></a>
         </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
          <a  [routerLink]="['/dashboard','DewormingManagement']"  routerLinkActive="active-link" ><div class="card card-stats" style="cursor:pointer"> 
               <div class="card-header card-header-warning card-header-icon">
                <p class="card-category">PARASITE MANAGEMENT</p>
               </div>
               <div class="card-icon">
                <img alt="" src="assets/images/Vaccine_management.png" />
               </div>
     
           </div></a>
         </div>-->
        
       </div>
     </div>
   </div>
 </div>    
      <!--<footer class="footer">
        <div class="container-fluid">
          <nav class="float-left">
            <ul>
              <li>
                <a href="#">
                  Creative Tim
                </a>
              </li>
              <li>
                <a href="#">
                  About Us
                </a>
              </li>
              <li>
                <a href="#">
                  Blog
                </a>
              </li>
              <li>
                <a href="#">
                  Licenses
                </a>
              </li>
            </ul>
          </nav>
          <div class="copyright float-right">
            &copy;
            <script>
              document.write(new Date().getFullYear())
            </script>, All Right reserved by
            <a href="#" target="_blank">Redantmedia</a> 
          </div>
        </div>
      </footer>-->

<!-------------END CARD-------------->
       